module.exports = __webpack_public_path__ + "static/media/phoneIcon.e4399a3c.svg";